import styled from 'styled-components';
import mainColors from '../../main-colors';
import sizeStandards from '../../size-standards';

// Single wrapper
const SwitchWrapper = styled.label`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  position: relative;
  user-select: none;

  input[type='checkbox'] {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background: ${mainColors.main_color};
    }

    &:checked + .slider::before {
      transform: translateX(20px);

      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        transform: translateX(19px);
      }
    }

    /* &:focus + .slider {
      box-shadow: 0px 0px 6px 0px ${mainColors.text_color};
    } */

    &:disabled + .slider {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .slider {
    position: relative;
    width: 44px;
    height: 24px;
    background-color: ${mainColors.addOpacityTo(mainColors.text_color_disabled, 0.4)};
    border-radius: 24px;
    transition: background-color 0.25s ease;

    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      width: 38px;
      height: 20px;
    }

    &::before {
      content: '';
      position: absolute;
      height: 18px;
      width: 18px;
      left: 3px;
      top: 3px;
      background-color: white;
      border-radius: 50%;
      transition: transform 0.25s ease;

      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        height: 15px;
        width: 15px;
        left: 2px;
        top: 2px;
      }
    }
  }

  .label-text {
    margin: 0;
  }

  .error-message {
    font-size: ${sizeStandards.font.MD}px;
    color: ${mainColors.error_color};
  }
`;

export default SwitchWrapper;
